import { gql } from '@apollo/client';

export const GET_AD_ACCOUNT_IDS_BY_CAMPAIGNS = gql`
  query getAdAccountIdsByCampaigns($campaignIds: [ID!]!) {
    getAdAccountIdsByCampaigns(campaignIds: $campaignIds)
  }
`;
